import imgUrlFor from "../functions/imgUrlFor";
import styles from "./ProportionateImageGrid.module.css";

export default function ProportionateImageGrid({ value }: { value: any }) {
	return (
		<div className={`${styles.galleryImageGrid} ${styles.gallery}`}>
			{value?.images.map((image: any, index: number) => {
				{
					return (
						<div className={styles.imageContainer} key={index + "container"}>
							<img
								width={1600}
								key={index}
								alt={image.alt || " "}
								loading="lazy"
								src={
									imgUrlFor(image)
										.width(1600)
										// .fit("max")
										.auto("format")
										.url() as string
								}
							/>
						</div>
					);
				}
			})}
		</div>
	);
}
